



































































import {
  Component, Vue, Prop, Watch,
} from 'vue-property-decorator';
import ButtonComponent from '@/shared/button/button.component.vue';
import WorkItemOptionListService from '@/views/work-item/work-item-option-list.service';
import OptionHeaders from '@/views/work-item/option-header.json';

@Component({
  components: {
    ButtonComponent,
  },
})
export default class WorkItemOptionList extends Vue {
  private dialog?: boolean = false;

  private selected: any = [];

  private active?: boolean;

  private options: any[] = OptionHeaders;

  created() {
    WorkItemOptionListService.getColumnSaved(this.options);
  }

  openModal() {
    WorkItemOptionListService.getColumnSaved(this.options);
    this.dialog = true;
  }

  cancelAndClose() {
    this.dialog = false;
  }

  saveAndClose() {
    this.save();
    this.dialog = false;
  }

  save() {
    const checkboxesState = this.options
      .map(option => ({
        value: option.value,
        active: option.active,
      }));
    const parsed = JSON.stringify(checkboxesState);
    localStorage.setItem('selected', parsed);
    this.$emit('updateColumn', parsed);
  }

  updateSelected(option: any, value: boolean) {
    option.active = value;
  }
}
